
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.293 3.293A1 1 0 0110 3h4a1 1 0 011 1v1H9V4a1 1 0 01.293-.707zM7 5V4a3 3 0 013-3h4a3 3 0 013 3v1h4a1 1 0 110 2h-1v13a3 3 0 01-3 3H7a3 3 0 01-3-3V7H3a1 1 0 010-2h4zM6 7v13a1 1 0 001 1h10a1 1 0 001-1V7H6zm4 3a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm5 7v-6a1 1 0 10-2 0v6a1 1 0 102 0z","fill":"#04080E"}})])
          )
        }
      }
    